import {ERequestType} from "@gongt/ts-stl-library/request/request";
import {ApiRequest, ApiResponse} from "@gongt/ts-stl-library/request/protocol";

export const UpdatePasswordUrl = `/do_update_password`;
export const UpdatePasswordMethod = ERequestType.TYPE_POST;

export interface UpdatePasswordBody extends ApiRequest {
	current: string;
	password: string;
	token: string;
}

export interface UpdatePasswordResponse extends ApiResponse {
}
